<template>
  <div class="page-container">
    <section class="mt-10 mb-10">
      <h1 class="font-size--24 mb-4">비상금론 펀딩 수수료 환급을 위한 설문(3문항)</h1>
      
      <div class="info-box mb-6">
        <p class="highlight mb-4">아래 설문에 응해주시면 비상금론 펀딩 수수료 최대 9만원(펀딩 금액의 3%)을 전액 환급해 드립니다!</p>
        <ul class="mb-4">
          <li>본 설문은 펀다의 제휴금융사인 '메타리치 주식회사'의 '보험자산 분석서비스'가 제공합니다.</li>
        </ul>
      </div>

      <div class="survey-section">
        <h2 class="survey-title">설문 1</h2>
        <p class="mb-3">본인은 펀다의 제휴금융사인 '메타리치 주식회사'의 '보험자산 분석 컨설팅 서비스'를 받아볼 용의가 있다.</p>
        <p class="notice mb-4">*본 '보험자산 분석 컨설팅 서비스'는 대출 과정 중 발생할 수 있는 위험에 대비한 보장자산 확인을 통해 추후 대출 금리 인하 및 펀딩 수수료 환급 등 맞춤 혜택이 제공됩니다</p>
        
        <v-radio-group v-model="survey.consulting" row>
          <v-radio label="있다" value="yes"></v-radio>
          <v-radio label="없다" value="no"></v-radio>
        </v-radio-group>
      </div>

      <template v-if="survey.consulting != 'no'">
        <div class="survey-section">
          <h2 class="survey-title">설문 2</h2>
          <p class="mb-3">본인이 월 납입하는 현재 보험료의 총 월 납입 금액은?</p>
          <v-radio-group v-model="survey.monthlyPayment">
            <v-radio label="10만원 이하" value="0-10"></v-radio>
            <v-radio label="10만원 이상 - 50만원 이하" value="10-50"></v-radio>
            <v-radio label="50만원 이상 - 100만원 이하" value="50-100"></v-radio>
            <v-radio label="100만원 이상 - 200만원 이하" value="100-200"></v-radio>
            <v-radio label="기타" value="etc"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="survey.monthlyPayment === 'etc'"
            v-model="survey.monthlyPaymentEtc"
            label="기타 금액"
            outlined
            dense
          ></v-text-field>
        </div>

        <div class="survey-section">
          <h2 class="survey-title">설문 3</h2>
          <p class="mb-3">사망보험금의 납입 금액은?</p>
          <v-radio-group v-model="survey.deathBenefit">
            <v-radio label="10만원 이하" value="0-10"></v-radio>
            <v-radio label="10만원 이상 - 50만원 이하" value="10-50"></v-radio>
            <v-radio label="50만원 이상 - 100만원 이하" value="50-100"></v-radio>
            <v-radio label="100만원 이상 - 200만원 이하" value="100-200"></v-radio>
            <v-radio label="기타" value="etc"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="survey.deathBenefit === 'etc'"
            v-model="survey.deathBenefitEtc"
            label="기타 금액"
            outlined
            dense
          ></v-text-field>
        </div>

        <div class="completion-notice mt-6 mb-8">
          <p class="highlight-text">컨설팅에 동의하신 고객께는 메타리치 상담원이 상담일정 확정을 위해 전화를 드릴 예정이며,</p>
          <p class="highlight-text">응답해주시면 펀딩수수료 환급혜택이 최종 확정됩니다.</p>
          <p>감사합니다.</p>
        </div>

        <div class="agreement-section">
          <v-checkbox
            v-model="survey.agreement"
            :rules="[v => !!v || '동의가 필요합니다']"
            class="mt-0"
          >
            <template v-slot:label>
              <div>
                <div class="agreement-label">
                  설문 내용과 상담용 연락처 공유에 동의합니다.
                </div>
                <div class="agreement-details">
                  <p>· 상담용 연락처 : 이름, 전화번호, 사업자명, 사업자등록번호</p>
                  <p>· 공유 대상 : 메타리치 주식회사</p>
                </div>
              </div>
            </template>
          </v-checkbox>
        </div>
      </template>

      <!-- <div v-else-if="survey.consulting === 'no'" class="mt-6 text-center">
        <p class="color--nice-grey">설문에 응답해 주셔서 감사합니다.</p>
        <p class="color--nice-grey">비상금 신청을 계속 진행하시겠습니까?</p>
        <BasicButton 
          class="mt-4" 
          depressed 
          height="48" 
          @click="proceedWithoutSurvey"
        >
          비상금 신청하기
        </BasicButton>
      </div> -->
    </section>

    <v-footer v-if="survey.consulting === 'yes'" fixed>
      <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
        <BasicButton 
          class="button next-button" 
          depressed 
          height="48" 
          @click="submitSurvey"
          :disabled="!isFormValid"
        >
          제출하고 비상금 신청하기
        </BasicButton>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  data() {
    return {
      survey: {
        consulting: null,
        monthlyPayment: null,
        monthlyPaymentEtc: '',
        deathBenefit: null,
        deathBenefitEtc: '',
        agreement: false
      },
      componentGetOffer: null
    }
  },
  created() {
    // URL query에서 offer 데이터 복원
    if (this.$route.query.offer) {
      this.componentGetOffer = JSON.parse(this.$route.query.offer)
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    form() {
      if (!this.componentGetOffer?.offer) {
        return null
      }

      const {
        commissionRate,
        repaymentRatio,
        interestRate,
        overdueInterestRate,
        amount,
        uuid: initOfferUuid,
        periodInDays: repaymentPeriodInDays,
        loanType: type,
      } = this.componentGetOffer.offer
      
      return {
        amount,
        type: 'fast_loan',
        interestRate,
        overdueInterestRate,
        repaymentRatio,
        commissionRate,
        repaymentPeriodInDays,
        initOfferUuid,
        disbursements: [],
      }
    },
    isFormValid() {
      return this.survey.consulting && 
             this.survey.monthlyPayment && 
             this.survey.deathBenefit &&
             !(this.survey.monthlyPayment === 'etc' && !this.survey.monthlyPaymentEtc) &&
             !(this.survey.deathBenefit === 'etc' && !this.survey.deathBenefitEtc) &&
             this.survey.agreement
    }
  },
  methods: {
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
    }),
    async submitSurvey() {
      try {
        // 설문 응답 데이터 포맷팅 및 제출
        const surveyData = {
          responses: [
            {
              question: "본인은 펀다의 제휴금융사인 '메타리치 주식회사'의 '보험자산 분석 컨설팅 서비스'를 받아볼 용의가 있다.",
              answer: this.survey.consulting === 'yes' ? '있다' : '없다'
            },
            {
              question: "본인이 월 납입하는 현재 보험료의 총 월 납입 금액은?",
              answer: this.formatPaymentAnswer(this.survey.monthlyPayment, this.survey.monthlyPaymentEtc)
            },
            {
              question: "사망보험금의 납입 금액은?",
              answer: this.formatPaymentAnswer(this.survey.deathBenefit, this.survey.deathBenefitEtc)
            }
          ],
          agreement: this.survey.agreement
        }

        // 설문 제출
        await defaultApi.postSurveyResponse(surveyData)

        // 대출 신청
        if (this.form) {
          await this.storeAddRequest(this.form)
        }

        // 다음 페이지로 이동
        await this.$router.push('/loan/fast-loan-300-check')
      } catch (error) {
        console.error('설문 제출 중 오류 발생:', error)
        await this.$swal.fire({
          title: '오류 발생',
          text: '설문 제출 중 문제가 발생했습니다. 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        })
      }
    },

    formatPaymentAnswer(value, etcValue) {
      const ranges = {
        '0-10': '10만원 이하',
        '10-50': '10만원 이상 - 50만원 이하',
        '50-100': '50만원 이상 - 100만원 이하',
        '100-200': '100만원 이상 - 200만원 이하'
      }
      
      if (value === 'etc') {
        return etcValue
      }
      return ranges[value]
    },

    async proceedWithoutSurvey() {
      try {
        // 대출 신청만 진행
        if (this.form) {
          await this.storeAddRequest(this.form)
        }
        await this.$router.push('/loan/fast-loan-300-check')
      } catch (error) {
        console.error('대출 신청 중 오류 발생:', error)
        await this.$swal.fire({
          title: '오류 발생',
          text: '대출 신청 중 문제가 발생했습니다. 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0px;
  padding-bottom: 80px;
}

.info-box {
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 8px;

  .highlight {
    color: #4163d5;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
    
    li {
      margin-bottom: 8px;
      color: #666;
    }
  }
}

.survey-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .survey-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
  }

  .notice {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
  }
}

.completion-notice {
  text-align: left;
  color: #666;
  line-height: 1.6;
  padding: 0 20px;

  p {
    margin-bottom: 8px;
  }

  .highlight-text {
    color: #4163d5;
    font-weight: 500;
  }
}

.v-footer {
  background-color: white !important;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
}

.agreement-section {
  margin: 20px 0;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .agreement-label {
    font-size: 14px;
    color: #333;
    line-height: 1.4;
    margin-bottom: 8px;
  }

  .agreement-details {
    font-size: 10px;
    color: #666;
    line-height: 1.4;
    padding-left: 4px;

    p {
      margin: 2px 0;
    }
  }

  :deep(.v-input--selection-controls) {
    margin: 0;
    padding: 0;
  }
}
</style>
